export default "__VITE_ASSET__69f7d8c2__"